// MUI
import { Container } from '@mui/material';
import Grid from '@mui/material/Grid';

// Store
import { useAppSelector } from '../../store/hooks';

// Content
import RenderContent from '../RenderContent';
import { EditableContentType } from '../IEditableContent';

export interface ContentViewProps {
    type: EditableContentType;
}

export default function ContentView(props: ContentViewProps) {
    const loginStatus = useAppSelector((state) => state.loginStatus);

    if (loginStatus.data.loggedIn === null) return <></>;

    return (
        <Container data-robot-id={'app-body-' + props.type}>
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <RenderContent
                        displayLoader
                        publicSite={!loginStatus.data.loggedIn}
                        type={props.type}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}
